var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4914 19.2964V22.9731H48.0794V29.5127H36.2749V33.1895H37.8631V39.7292H26.0585V43.406H27.6467V49.9456H15.842V53.6224H17.4303V62.0003H21.107V53.6224H31.3235V43.406H41.5398V33.1895H51.7563V22.9731H60.1343V19.2964H46.4914Z",
    fill: "#C6B193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7507 7.99975L9.86572 41.8848L12.4656 44.4846L46.3506 10.5996L43.7507 7.99975Z",
    fill: "#C6B193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStair);
export default __webpack_public_path__ + "static/media/stair.1f70e70abc09cdf7b10a5564e0eb6f1f.svg";
export { ForwardRef as ReactComponent };